var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDhoondh2Logo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 429,
    viewBox: "0 0 457 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 178.5,
    r: 56.5,
    fill: "#87DE88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.5 0C277.083 0 357 79.9172 357 178.5C357 211.189 348.21 241.824 332.869 268.175L456.993 381.996L414.011 428.868L291.589 316.608C291.508 316.675 291.425 316.74 291.344 316.807C285.001 297.104 273.62 279.663 258.717 266C282.247 244.428 297 213.438 297 179C297 113.83 244.17 61 179 61C113.83 61 61 113.83 61 179C61 213.437 75.7528 244.428 99.2822 266C84.2162 279.812 72.7495 297.487 66.4492 317.455C25.9218 284.733 0 234.644 0 178.5C0 79.9172 79.9172 0 178.5 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.562 284.232C141.606 292.396 159.765 297 179 297C197.992 297 215.936 292.511 231.83 284.539C247.628 296.979 259.152 314.816 263.771 335.352C238.435 349.155 209.384 357 178.5 357C147.616 357 118.564 349.155 93.2266 335.352C97.8836 314.647 109.562 296.685 125.562 284.232Z",
    fill: "#87DE88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhoondh2Logo);
export default __webpack_public_path__ + "static/media/dhoondh2-logo.7f3b9102c90bcab78f03ce8f19042e5f.svg";
export { ForwardRef as ReactComponent };